import { MarketDto, MarketTypeLayout } from './api/sbapi/sbapi-api-model';
import {
	MARKET_NAME_1X2,
	MARKET_NAME_WINNER,
	MARKET_TYPE_ID_1X2,
	MARKET_TYPE_ID_1X2_LIVE,
	MARKET_TYPE_ID_WINNER,
	MARKET_TYPE_ID_WINNER_LIVE,
	MARKET_NAME_WINNER_INCLUDING_OVERTIME,
	MARKET_NAME_MONEYLINE,
	MARKET_TYPE_ID_WINNER_INCLUDING_SUPER_OVER,
	MARKET_NAME_WINNER_INCLUDING_EXTRA_INNINGS,
	MARKET_NAME_WINNER_INCLUDING_SUPER_OVER,
	MARKET_TYPE_ID_WINNER_INCLUDING_EXTRA_INNINGS,
	MARKET_TYPE_ID_WINNER_INCLUDING_OVERTIME
} from './sportsbook-constants';
import { MarketWithMergedMarketsAndSelections } from './sportsbook-types';

// TODO break utils out to smaller files and create a utils folder for the whole lobby project.

export const is1X2Market = (market: MarketDto | undefined) => {
	if (!market?.marketType) {
		return false;
	}

	const hasCorrectMarketType = [MARKET_TYPE_ID_1X2, MARKET_TYPE_ID_1X2_LIVE].includes(market.marketType.id);
	const hasCorrectMarketName =
		market.marketType.originalName?.toUpperCase() === MARKET_NAME_1X2 ||
		market.marketType.name.toUpperCase() === MARKET_NAME_1X2;

	return hasCorrectMarketType && hasCorrectMarketName;
};

export const isWinnerMarket = (market: MarketDto | undefined) => {
	if (!market?.marketType) {
		return false;
	}

	const hasCorrectMarketType = [
		MARKET_TYPE_ID_WINNER,
		MARKET_TYPE_ID_WINNER_LIVE,
		MARKET_TYPE_ID_WINNER_INCLUDING_OVERTIME,
		MARKET_TYPE_ID_WINNER_INCLUDING_SUPER_OVER,
		MARKET_TYPE_ID_WINNER_INCLUDING_EXTRA_INNINGS
	].includes(market.marketType.id);

	const hasCorrectMarketName = [
		MARKET_NAME_WINNER,
		MARKET_NAME_WINNER_INCLUDING_OVERTIME,
		MARKET_NAME_MONEYLINE,
		MARKET_NAME_WINNER_INCLUDING_EXTRA_INNINGS,
		MARKET_NAME_WINNER_INCLUDING_SUPER_OVER
	].includes(market.marketType.originalName || market.marketType.name); // we need to check originalName because name is translated

	return hasCorrectMarketType && hasCorrectMarketName;
};

export const isMergedLayoutMarket = (market: MarketWithMergedMarketsAndSelections) => {
	return [MarketTypeLayout.MERGED, MarketTypeLayout.MERGED_TABLE].includes(market.marketType.marketTypeLayout);
};

export const isPlayerPropsMarket = (market: MarketWithMergedMarketsAndSelections) => {
	return [MarketTypeLayout.PLAYER_PROPS].includes(market.marketType.marketTypeLayout);
};

export const subscriptionRefWithSuffixes = (reference: string, ...suffixes: string[]) => {
	if (!suffixes || suffixes.length === 0) {
		return reference;
	}

	return suffixes.reduce((result, suffix) => `${result}_${suffix}`, reference);
};
